export const shareTwitterText = 'Check out the Badlands Draft Guide!';
export const patreonUrl = 'https://www.patreon.com/BadlandsTOJ';
export const hashtag = 'BadlandsDraftGuide';

export const spShareTwitterText = 'Check out the Badlands Season Preview Guide';
export const spPatreonUrl = 'https://badlands.guide/draft';
export const spHashtag = 'BadlandsSeasonPreview';

export const credits = {
  bigBoard: {
    twitter: '@ConnorJRogers',
    link: 'https://twitter.com/ConnorJRogers',
  },
};

export const twitterLink = 'https://www.badlandstoj.com/twitter-handles';
export const youtubeLink = 'https://www.youtube.com/user/TurnOnTheJetsTV';
export const instagramLink = 'https://www.instagram.com/badlands_toj/';
export const tiktokLink = 'https://www.tiktok.com/@turnonthejets';

export const socialLinks = {
  twitter: twitterLink,
  youtube: youtubeLink,
  instagram: instagramLink,
  tiktok: tiktokLink,
};
